import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { setLoading} from "../../services/global/globalSlice"
import { useEffect, useState } from "react"
import { fetchEditFolder, fetchGetFolder } from "./FolderApi"
import { toast } from "react-toastify"
import SubFolders from "./_components/SubFolders"

import add_img from '../../assets/images/add.svg'
import add_blue_img from '../../assets/images/add_blue.svg'
import training_img from '../../assets/images/folders/training.svg'
import folder_img from '../../assets/images/folders/folder.svg'
import lesson_img from '../../assets/images/folders/lesson.svg'
import link_img from '../../assets/images/folders/link.svg'
import file_img from '../../assets/images/folders/file.svg'
import video_img from '../../assets/images/folders/video.svg'
import icon_formazione from '../../components/Navigation/icons/formazione.svg'

import File from "./_components/File"

import { DndContext, closestCenter } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useSortable, rectSortingStrategy } from "@dnd-kit/sortable";
import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { CSS } from '@dnd-kit/utilities';

import './FoldersScreen.css'
import { Dropdown, Tabs, Tab} from "react-bootstrap"
import ContentCreateModal from "./_components/ContentCreateModal"
import ConfirmModal from "../../components/_modals/ConfirmModal"
import { prepareFolderData } from "./folderUtils"
import ContentEditModal from "./_components/ContentEditModal"
import { randomUid } from "../../utils/utils"
import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding } from "../../features/User/userSlice"
import { trainingsTourSteps } from "../../config/tour"

export default function FoldersScreen() {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {folder_id} = useParams()
    const [folderData, setFolderData] = useState({})
    const [contentModal, setContentModal] = useState({
        show: false,
        type: 'video',
    })
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })
    const [selectedContent, setSelectedContent] = useState({
        type: null,
        index: null,
        show: false
    })
    const [isUpdated, setIsupdated] = useState(false)

    const loadFolderDetails = async () => {
        dispatch(setLoading(true))
        const response = await fetchGetFolder({...(folder_id && {folder_id: folder_id})})
        if (response.success){
            if(!response.data?.parent_folder_id)
                navigate("/folders", {replace:true})
            if(response.data?.links)
                response.data?.links.map(l => l['file_id']=randomUid())
            setFolderData(response.data)
            setIsupdated(false)
            dispatch(setLoading(false))
        } else {
            toast.error(t.training.error_loading_folder)
            dispatch(setLoading(false))
        }
    }

    const handleAddVideo = (e) => {
        console.log(e)
    }

    //Drag&Drop
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 10 } }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragEndFiles = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.files.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.files.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.files, oldIndex, newIndex);
            console.log(updatedFiles);
            
            setFolderData({
                ...folderData,
                files: updatedFiles,
            });
        }
    };

     const handleDragEndVideos = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.videos.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.videos.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.videos, oldIndex, newIndex);
            
            setFolderData({
                ...folderData,
                videos: updatedFiles,
            });
        }
    };

    const handleDragEndLinks = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.links.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.links.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.links, oldIndex, newIndex);
            
            setFolderData({
                ...folderData,
                links: updatedFiles,
            });
        }
    };

    /*CONTENT */
    const handleCloseContentModal = () => {
        loadFolderDetails()
        setContentModal({
            ...contentModal,
            show: false
        })
    }

    const handleAddContent = (type) => {
        setContentModal({
            ...contentModal,
            show: true,
            type: type
        })
    }

    const openContent = (type, index) => {
        setSelectedContent({
            ...selectedContent,
            show: true,
            type: type,
            index: index
        })
    }

    const handleCloseSelectedContent = async (update = false, suggest_save=false) => {
        if(update){
            let _folderData = structuredClone(folderData)
            _folderData = prepareFolderData(_folderData)
            const response = await fetchEditFolder({folder_id: folderData.folder_id}, _folderData)
            if(response.success){
                toast.success(t.folder.folder_updated)
                setSelectedContent({
                    ...selectedContent,
                    show: false,
                })
            } else {
                toast.error("Errore durante la modifica della cartella")
            }
        } else {
            setSelectedContent({
                ...selectedContent,
                show: false,
            })
            if(suggest_save)
                setIsupdated(true)
        }
    }

    const handleFolderDataChange = (data) => {
        setFolderData(data)
    }

    const handlePubblishFolder = async () => {
        dispatch(setLoading(true))
        let _folderData = structuredClone(folderData)
        _folderData = prepareFolderData(_folderData)
        _folderData['state'] = "ready"
        _folderData['allowed_all'] = true
        const response = await fetchEditFolder({folder_id: folderData.folder_id}, _folderData)
        if(response.success){
            toast.success(t.folder.folder_published)
            setConfirmModal({
                ...confirmModal,
                show: false
            })
            loadFolderDetails()
        } else {
            toast.error("Errore durante la pubblicazione della cartella")
        }
        dispatch(setLoading(false))
    }
    
    useEffect(()=>{
        loadFolderDetails()
    },[])

    useEffect(()=>{
        loadFolderDetails()
    },[folder_id])

    const userOnboarding  = useSelector(selectUserOnboarding)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    const userData = useSelector(selectUserData)
    
    useEffect(()=>{
        setIsOpen(false)
        if(!userData?.is_super_admin){
            if((
                    !userOnboarding?.trainings?.section_completed 
                ) && userOnboarding?.trainings?.step_completed_count <= 2){
                setTimeout(()=>{    
                    if(window.location.pathname?.includes("folders"))
                        setIsOpen(true)
                },1500)
                setSteps(trainingsTourSteps)
                setCurrentStep(userOnboarding?.trainings?.step_completed_count)
                setMeta('trainings')
            } else if(userOnboarding?.trainings?.step_completed_count > 2 && (
                    !userOnboarding?.trainings?.section_completed 
                )) {
                setTimeout(()=>{
                    if(window.location.pathname?.includes("folders"))
                        setIsOpen(true)
                },1500)
                setSteps(trainingsTourSteps)
                setCurrentStep(2)
                setMeta('trainings')
            }
        }
    },[])

    return(
        <div className="p-2">
            <div className="d-flex justify-content-between">
                <div className="page_title">
                    <img src={icon_formazione} />
                    <h1>{t.folders.page_title}</h1>
                </div>
                <div>
                    <Dropdown>
                        <Dropdown.Toggle as={'div'} bsPrefix="custom" split={true} id="dropdown-basic">
                            <button className="trainigs-step-1">
                                {t.folders.add}
                                <img src={add_img} />
                            </button>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item >
                                <Link to={`/folder/create/${folderData?.folder_id}`}>
                                    <img src={folder_img} className="me-1"/>
                                    {t.folders.folder}
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item disabled={true} >
                                <img src={training_img} className="me-1"/>
                                {t.folders.training}
                            </Dropdown.Item>
                            <Dropdown className="dropdown-item" >
                                <Dropdown.Toggle as={'span'}  id="dropdown-nested">
                                        <img src={lesson_img} className="me-1" />
                                        {t.folders.material}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item  onClick={()=>handleAddContent('file')}>
                                        <img src={file_img} className="me-1"/>
                                        {t.folder.file}
                                    </Dropdown.Item>
                                    <Dropdown.Item  onClick={()=>handleAddContent('video')}>
                                        <img src={video_img} className="me-1"/>
                                        {t.folder.video}
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={()=>handleAddContent('link')} >
                                        <img src={link_img} className="me-1"/>
                                        {t.folder.link}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                
                
            </div>

                <Tabs
                    defaultActiveKey="general"
                    id="noanim-tab-example"
                    className="mt-3 mb-4 trainigs-step-0"
                >
                    <Tab eventKey="general" title={t.folders.folders}>
                        <div className="trainigs-step-2">
                            {folderData.folder_id ? 
                                <div className="mt-3 ">
                                    <SubFolders 
                                        parentFolder={folderData} 
                                        additionalElement={
                                            <div className="new_element h-100">
                                                <div>
                                                    <img src={folder_img} alt=""/>
                                                    <h3 style={{color:"#6D6F73"}}>{t.folder.new_folder}</h3>
                                                    <Link to={`/folder/create/${folderData?.folder_id}`}>
                                                        <button className="secondary mx-auto mt-3">{t.folder.add} <img src={add_blue_img} /></button>
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                        showAdditionalElement={true}
                                    />
                                </div> : null
                            }
                        </div>
                    </Tab>
                    <Tab eventKey="materials" title={t.folder.materials}>
                        <h2>{t.folder.training}</h2>
                        {
                            folderData?.training ?
                                <div className={`new_element reduced ${folderData?.training?.ready ? 'border border-2 border-success': ''}`}>
                                    <img src={training_img} alt=""/>
                                    <h3 style={{color:"#6D6F73"}}>{folderData?.training?.training_title}</h3>
                                    <Link to={`/training/details/${folderData?.folder_id}`}>
                                        <button className="secondary mx-auto mt-3">{t.folder.edit}</button>
                                    </Link>
                                    
                                </div>
                            : <div className="new_element reduced">
                                    <img src={training_img} alt=""/>
                                    <h3 style={{color:"#6D6F73"}}>{t.folder.new_traininig}</h3>
                                    <Link to={`/training/create/${folderData?.folder_id}`}>
                                        <button className="secondary mx-auto mt-3">{t.folder.add} <img src={add_blue_img} /></button>
                                    </Link>
                                    
                                </div>
                        }
                        { folderData?.videos?.length > 0 && <>
                        <h2 className="mt-3">{t.folder.video}</h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndVideos}>
                            <SortableContext items={folderData.videos.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mt-2">
                                    {folderData.videos.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'video'} onClick={() => openContent('videos', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                    { folderData?.files?.length > 0 && <>
                        <h2 className="mt-3">{t.folder.file}</h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndFiles}>
                            <SortableContext items={folderData.files.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mt-2">
                                    {folderData.files.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'file'} onClick={() => openContent('files', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                    { folderData?.links?.length > 0 && <>
                        <h2 className="mt-3">{t.folder.link}</h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndLinks}>
                            <SortableContext items={folderData.links.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mt-2">
                                    {folderData.links.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'link'} onClick={() => openContent('links', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                    </Tab>
                </Tabs>
              <ConfirmModal props={confirmModal}/>
                <ContentEditModal
                    folderData={folderData} 
                    type={selectedContent.type} 
                    index={selectedContent.index} 
                    show={selectedContent.show} 
                    onClose={handleCloseSelectedContent} 
                    onFolderDataChange={handleFolderDataChange} 
                />
            <ContentCreateModal  show={contentModal.show} type={contentModal.type} folderData={folderData || null} onClose={handleCloseContentModal} />
            <footer className='control-footer'>
                    <div className='d-flex align-items-center justify-content-end'>
                        <div className='d-flex justify-content-end'>
                            <button  className={isUpdated ? "highlight" : ""} onClick={handlePubblishFolder}>
                                {t.buttons.save_and_pubblish}
                            </button>
                        </div>
                    </div>
                </footer>
          </div>
    )
}

function SortableItem(props) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    
    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {props.children}
        </div>
    );
}